<template>
  <v-card class="nospace accounts-list-card oms-list-table-card">
    <loading :active.sync="loading" />
    <v-card-text class="nospace accounts-table-card">
      <ScrollableTable
        class="accounts-table-scroll oms-list-table-scroll"
        min-width="var(--accounts-job-table-min-width, 100%)"
      >
        <v-data-table
          id="dataTable"
          class="accounts-modern-table oms-list-table"
          style="
            --oms-list-col-1: 8%;
            --oms-list-col-3: 11%;
            --oms-list-col-5: 10%;
            --oms-list-col-6: 7%;
            --oms-list-col-7: 11%;
            --oms-list-col-8: 8%;
            --oms-list-col-9: 8%;
            --oms-list-col-10: 10.25%;
          "
          hide-actions
          item-key="jobId"
          :headers="headers"
          :items="items"
          :disable-initial-sort="true"
          :pagination.sync="pagination"
        >
        <template slot="items" slot-scope="props">
          <tr
            class="accounts-data-row"
            style="cursor: pointer"
            @click="openAccountDetail(props.item, $event)"
          >
            <td class="accounts-job-cell">
              <div class="accounts-job-id-row oms-id-cell" style="justify-content: center">
                <v-flex
                  v-if="customerSearchData"
                  class="accounts-job-select"
                  @click="stop($event)"
                >
                  <v-checkbox
                    class="align-center justify-center"
                    v-model="props.item.selected"
                    :disabled="
                      !props.item.voucherIdRealBooks ||
                      props.item.jobStatus == 5 ||
                      props.item.isSaleOrderBackgroundProcess ||
                      props.item.isSaleInvoviceBackgroundProcess ||
                      props.item.isSaleOrderInQueue ||
                      props.item.isAssignmentCustomerReceiptInitiated
                    "
                    @change="
                      checkSelected(
                        props.item.selected,
                        props.item.jobId,
                        $event
                      )
                    "
                    primary
                    hide-details
                    >
                  </v-checkbox>
                </v-flex>
                <activityLogs
                  class="pd_5"
                  :type="'jobs'"
                  :permissions="'activity-logs-for-accounts'"
                  :_id="props.item._id"
                  :id="props.item.jobId.toString()"
                />
                <span
                  class="accounts-job-id"
                  :class="{ 'accounts-job-id--selectable': customerSearchData }"
                  :title="props.item.jobId.toString()"
                >
                  {{ props.item.jobId }}</span
                >
              </div>
            </td>
            <td class="accounts-country-cell">
              <img
                v-if="props.item.workingCountry == 'PAK'"
                src="../../assets/pakflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'KSA'"
                src="../../assets/ksaflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE'"
                src="../../assets/Uaeflag.png"
                height="20px"
              /><img
                v-if="props.item.workingCountry == 'UAE LA'"
                src="../../assets/Uaeflag.png"
                height="20px"
                style="border-radius: 50%"
              />
              <img
                v-if="props.item.workingCountry == 'OMAN'"
                src="../../assets/omanflag.png"
                height="28px"
              />
              <br />{{ props.item.workingCountry || "-" }}
            </td>
            <td class="accounts-company-cell">
              {{ props.item.companyName || props.item.customer }}
            </td>
            <!-- <td>{{ getTime3(props.item.pickupDate) }}</td> -->
            <td class="accounts-money-cell">
              <v-layout class="justfy_c">
                <span style="padding-top: 12px">
                  {{
                    props.item.jobPrice
                      ? $formatPrice(props.item.jobPrice)
                      : "N.A"
                  }}
                  {{
                    props.item.jobPrice ? props.item.customerCurrency : ""
                  }}</span
                >
                <div v-if="!props.item.isJobActivatedByScript">
                  <CustomerPrice
                    v-permissions="'edit-customer-price-for-accounts'"
                    :priceData="props.item"
                    @account-list-refresh="
                      refresh();
                      getAssignmentList(props.item.jobId);
                    "
                  />
                </div>
              </v-layout>
            </td>
            <td class="accounts-status-cell">
              <span
                class="accounts-status-pill"
                :class="{
                  'accounts-status-pill--open':
                    props.item.jobStatus === 1 ||
                    props.item.jobStatus === 3 ||
                    props.item.jobStatus === 4,
                  'accounts-status-pill--moving':
                    props.item.jobStatus === 5 ||
                    props.item.jobStatus === 6 ||
                    props.item.jobStatus === 7,
                  'accounts-status-pill--pending':
                    props.item.jobStatus === 8 ||
                    props.item.jobStatus === 10,
                  'accounts-status-pill--done':
                    props.item.jobStatus === 9 ||
                    props.item.jobStatus === 2,
                  'accounts-status-pill--cancelled':
                    props.item.jobStatus === -1
                }"
              >
                {{ jobsStatus(props.item.jobStatus) }}
              </span>
            </td>
            <td class="accounts-price-type-cell">
              <v-layout class="justfy_c">
                <span style="padding-top: 12px">
                  {{ props.item.chargesType }}</span
                >
                <div v-if="!props.item.isJobActivatedByScript">
                  <PriceType
                    v-permissions="'job-price-type-for-accounts'"
                    :jobId="props.item.jobId"
                    :chargesType="props.item.chargesType"
                    @account-list-refresh="
                      refresh();
                      getAssignmentList(props.item.jobId);
                    "
                  />
                </div>
              </v-layout>
            </td>
            <td class="accounts-charges-cell">
              <v-layout class="justfy_c">
                <div style="display: flex; align-items: center">
                  <v-flex>
                    <div style="padding-top: 3px">
                      Misc:&nbsp;
                      {{
                        props.item.miscellaneousCharge
                          ? props.item.miscellaneousCharge
                          : "0"
                      }}
                      {{
                        props.item.miscellaneousCharge
                          ? props.item.customerCurrency
                          : ""
                      }}
                    </div>
                    <div style="padding-top: 3px">
                      Driver:&nbsp;
                      {{
                        props.item.additionalCharges
                          ? props.item.additionalCharges
                          : "0"
                      }}
                      {{
                        props.item.additionalCharges
                          ? props.item.customerCurrency
                          : ""
                      }}
                    </div>

                    <div style="padding-top: 3px">
                      Customer:&nbsp;
                      {{ props.item.costMargin ? props.item.costMargin : "0" }}
                      {{
                        props.item.costMargin ? props.item.customerCurrency : ""
                      }}
                    </div>
                  </v-flex>

                  <div v-if="!props.item.isJobActivatedByScript">
                    <additionalChargesPopup
                      v-permissions="'additional-charge-for-accounts'"
                      @account-list-refresh="
                        refresh();
                        getAssignmentList(props.item.jobId);
                      "
                      :_id="props.item._id"
                      :id="props.item.jobId"
                      :jobCurrency="props.item.customerCurrency"
                      :jobSalesInvoice="props.item.isSalesInvoiceGenerated"
                    />
                  </div>
                </div>
              </v-layout>
            </td>
            <td class="accounts-money-cell accounts-driver-rate-cell">
              {{
                props.item.driverRate
                  ? $formatPrice(props.item.driverRate)
                  : "N.A"
              }}
              {{ props.item.driverRate ? props.item.customerCurrency : "" }}
            </td>
            <td class="accounts-action-cell accounts-po-cell">
              <button
                v-permissions="'generate-downaload-so-si-for-accounts'"
                class="account-disabled-ass-btn"
                flat
                prepend-icon
                color="white darken-1"
                type="button"
                @click.stop="openAccountDetail(props.item, $event, true)"
              >
                View
              </button>
            </td>
            <td class="accounts-action-cell accounts-sales-order-cell">
              <v-flex
                v-if="
                  props.item.workingCountry == 'PAK' ||
                  props.item.workingCountry == 'OMAN'
                "
                >-</v-flex
              >
              <v-flex
                v-else-if="
                  (!props.item.workOrderCompleted &&
                    props.item.workingCountry != 'PAK') ||
                  (!props.item.workOrderCompleted &&
                    props.item.workingCountry != 'OMAN')
                "
              >
                Work Order not generated
                <v-flex
                  v-if="
                    props.item.workingCountry != 'PAK' ||
                    props.item.workingCountry != 'OMAN'
                  "
                >
                  <v-flex
                    v-if="
                      !props.item.userData.invoicingCity &&
                      props.item.userData.invoicingCountry
                    "
                  >
                    Please update customer invoicing details.
                  </v-flex>
                  <v-flex
                    v-else-if="
                      !props.item.userData.invoicingCity &&
                      !props.item.userData.invoicingCountry &&
                      !props.item.invoicingCompany &&
                      !props.item.invoicingCity
                    "
                  >
                    Please update customer invoicing details{{
                      props.item.invoicingCompany
                    }}{{ props.item.invoicingCity
                    }}{{ props.item.userData.invoicingCity
                    }}{{ props.item.userData.invoicingCountry }}
                  </v-flex>
                  <v-flex
                    v-else-if="
                      props.item.userData.companyVatNumber &&
                      props.item.userData.address &&
                      props.item.workOrderCompleted == false
                    "
                  >
                    <button
                      v-if="
                        (props.item.userData &&
                          props.item.userData.invoicingCity &&
                          props.item.userData.invoicingCountry) ||
                        (props.item.invoicingCompany &&
                          props.item.invoicingCity &&
                          !props.item.isWorkOrderInQueue)
                      "
                      class="track-ass-btn"
                      flat
                      prepend-icon
                      color="white darken-1"
                      @click="retry(props.item.jobId)"
                    >
                      Retry
                    </button>
                    <div v-if="props.item.isWorkOrderInQueue">
                      Background process is ongoing
                    </div>
                  </v-flex>
                  <v-flex
                    v-else-if="
                      props.item.userData &&
                      props.item.userData.companyVatNumber &&
                      props.item.userData.address
                    "
                  >
                    <button
                      class="track-ass-btn"
                      v-if="!props.item.isWorkOrderInQueue"
                      flat
                      prepend-icon
                      color="white darken-1"
                      @click="retry(props.item.jobId)"
                    >
                      Create
                    </button>
                    <div v-if="props.item.isWorkOrderInQueue">
                      Background process is ongoing
                    </div>
                  </v-flex>
                  <v-flex v-else>
                    Please Update Customer Billing address and Vat number*
                  </v-flex>
                </v-flex>

                <!-- Work order is not generated no -->
              </v-flex>
              <v-flex
                v-else-if="
                  props.item.workingCountry != 'PAK' ||
                  props.item.workingCountry != 'OMAN'
                "
              >
                <div v-if="props.item.isSaleOrderInQueue">
                  Background process is ongoing
                </div>
                <div v-else-if="!props.item.workOrderCompleted">
                  Work Order not generated
                  <v-flex
                    v-if="
                      props.item.workingCountry != 'PAK' ||
                      props.item.workingCountry != 'OMAN'
                    "
                  >
                    <v-flex
                      v-if="
                        !props.item.userData.invoicingCity &&
                        props.item.userData.invoicingCountry
                      "
                    >
                      Please update customer invoicing details.
                    </v-flex>
                    <v-flex
                      v-else-if="
                        !props.item.userData.invoicingCity &&
                        !props.item.userData.invoicingCountry &&
                        !props.item.invoicingCompany &&
                        !props.item.invoicingCity
                      "
                    >
                      Please update customer invoicing details.
                    </v-flex>
                    <v-flex
                      v-else-if="
                        props.item.userData.companyVatNumber &&
                        props.item.userData.address &&
                        props.item.workOrderCompleted == false
                      "
                    >
                      <button
                        v-if="
                          (props.item.userData &&
                            props.item.userData.invoicingCity &&
                            props.item.userData.invoicingCountry) ||
                          (props.item.invoicingCompany &&
                            props.item.invoicingCity &&
                            !props.item.isWorkOrderInQueue)
                        "
                        class="track-ass-btn"
                        flat
                        prepend-icon
                        color="white darken-1"
                        @click="retry(props.item.jobId)"
                      >
                        Retry
                      </button>
                      <div v-if="props.item.isWorkOrderInQueue">
                        Background process is ongoing
                      </div>
                    </v-flex>
                    <v-flex
                      v-else-if="
                        props.item.userData &&
                        props.item.userData.companyVatNumber &&
                        props.item.userData.address
                      "
                    >
                      <button
                        class="track-ass-btn"
                        v-if="!props.item.isWorkOrderInQueue"
                        flat
                        prepend-icon
                        color="white darken-1"
                        @click="retry(props.item.jobId)"
                      >
                        Create
                      </button>
                      <div v-if="props.item.isWorkOrderInQueue">
                        Background process is ongoing
                      </div>
                    </v-flex>
                    <v-flex v-else>
                      Please Update Customer Billing address and Vat number*
                    </v-flex>
                  </v-flex>

                  <!-- Work order is not generated no -->
                </div>
                <div v-else-if="props.item.jobStatus == -1">
                  Job is cancelled
                </div>
                <!-- <div v-else-if="detail.jobStatus == 4">Please assign driver</div> -->
                <div
                  v-else-if="
                    props.item.isSalesOrderIntiated &&
                    props.item.voucherIdRealBooks
                  "
                >
                  {{ props.item.voucherIdRealBooks }}
                </div>
                <div
                  v-else-if="
                    props.item.isSalesOrderIntiated == false &&
                    props.item.workOrderCompleted == true &&
                    props.item.errorWhileRealbooks == true
                  "
                >
                  <span v-if="props.item.isSaleOrderInQueue">
                    Background process are ongoing
                  </span>
                  <span
                    v-if="
                      !props.item.isSaleOrderInQueue &&
                      props.item.isSaleOrderBackgroundProcess &&
                      props.item.errorWhileRealbooks
                    "
                    >Data inappropriate, kindly update data</span
                  >
                  <button
                    class="track-ass-btn"
                    v-permissions="'generate-downaload-so-si-for-accounts'"
                    flat
                    v-if="
                      !props.item.isSaleOrderInQueue &&
                      !props.item.isSaleOrderBackgroundProcess &&
                      props.item.errorWhileRealbooks
                    "
                    prepend-icon
                    color="white darken-1"
                    @click="retrySO(props.item.jobId)"
                    :_id="props.item._id"
                  >
                    Retry
                  </button>
                </div>
                <div
                  v-else-if="
                    props.item.isReadyToGenerateSalesInvoice &&
                    props.item.isSalesOrderIntiated == false &&
                    !props.item.voucherIdRealBooks &&
                    props.item.workOrderCompleted == true
                  "
                >
                  <span v-if="props.item.isSaleOrderInQueue">
                    Background process is ongoing
                  </span>
                  <button
                    v-if="!props.item.isSaleOrderInQueue"
                    v-permissions="'generate-downaload-so-si-for-accounts'"
                    class="account-ass-btn"
                    flat
                    prepend-icon
                    color="white darken-1"
                    :disabled="loading"
                    @click="retrySO(props.item.jobId)"
                    :_id="props.item._id"
                  >
                    <v-icon color="orange" small>settings</v-icon> SO
                  </button>
                </div>
              </v-flex>
              <v-flex v-else>
                <!-- <span v-if="props.item.jobStatus != 5">-</span> -->
                <v-tooltip
                  v-if="
                    props.item.workingCountry != 'PAK' ||
                    props.item.workingCountry != 'OMAN'
                  "
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-permissions="'generate-downaload-so-si-for-accounts'"
                      class="account-disabled-ass-btn"
                      flat
                      prepend-icon
                      color="white darken-1"
                      disabled
                    >
                      <v-icon style="color: lightgray !important" small
                        >settings</v-icon
                      >
                      SO
                    </button></template
                  >
                  <span class="tooltip"
                    >Complete shipment to create sales order.</span
                  >
                </v-tooltip>
              </v-flex>
            </td>
            <td class="accounts-action-cell accounts-sales-invoice-cell" v-if="props.item.invoiceNumber == 'NA'">
              N.A.
            </td>
            <td class="accounts-action-cell accounts-sales-invoice-cell" v-else>
              <v-flex
                v-if="
                  props.item.workingCountry == 'PAK' ||
                  props.item.workingCountry == 'OMAN'
                "
                >-</v-flex
              >
              <v-flex
                v-else-if="
                  (!props.item.workOrderCompleted &&
                    props.item.workingCountry != 'PAK') ||
                  (!props.item.workOrderCompleted &&
                    props.item.workingCountry != 'OMAN')
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-permissions="'generate-downaload-so-si-for-accounts'"
                      class="account-disabled-ass-btn"
                      flat
                      prepend-icon
                      color="white darken-1"
                      disabled
                    >
                      <v-icon style="color: lightgray !important" small
                        >settings</v-icon
                      >
                      SI
                    </button></template
                  >
                  <span class="tooltip"
                    >Generate SO to generate sales invoice.</span
                  >
                </v-tooltip>
              </v-flex>
              <v-flex
                v-else-if="
                  !props.item.isSalesInvoiceGenerated &&
                  !props.item.invoiceNumber &&
                  !props.item.isReadyToGenerateSalesInvoice &&
                  !props.item.invoicePdfUrl &&
                  props.item.VendorWorkingCountry != 'PAK' &&
                  props.item.VendorWorkingCountry != 'OMAN'
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-permissions="'generate-downaload-so-si-for-accounts'"
                      class="account-disabled-ass-btn"
                      flat
                      prepend-icon
                      color="white darken-1"
                      disabled
                    >
                      <v-icon style="color: lightgray !important" small
                        >settings</v-icon
                      >
                      SI
                    </button></template
                  >
                  <span v-if="!props.item.voucherIdRealBooks" class="tooltip"
                    >Generate SO to generate sales invoice.</span
                  >

                  <span v-if="props.item.voucherIdRealBooks" class="tooltip"
                    >Complete shipment to generate sales invoice.</span
                  >
                </v-tooltip>
              </v-flex>

              <v-flex
                v-if="
                  props.item.isReadyToGenerateSalesInvoice &&
                  !props.item.isSalesInvoiceGenerated &&
                  props.item.workOrderCompleted &&
                  props.item.workingCountry != 'PAK' &&
                  !props.item.isSaleOrderInQueue &&
                  props.item.isAssignmentCustomerReceiptInitiated &&
                  props.item.workingCountry != 'OMAN'
                "
              >
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-permissions="'generate-downaload-so-si-for-accounts'"
                      class="account-disabled-ass-btn"
                      flat
                      prepend-icon
                      color="white darken-1"
                      disabled
                    >
                      <v-icon style="color: lightgray !important" small
                        >settings</v-icon
                      >
                      SI
                    </button></template
                  >
                  <span class="tooltip">Customer Receipt Initiated</span>
                </v-tooltip>
              </v-flex>

              <v-flex
                v-if="
                  props.item.isReadyToGenerateSalesInvoice &&
                  !props.item.isSalesInvoiceGenerated &&
                  props.item.workOrderCompleted &&
                  props.item.workingCountry != 'PAK' &&
                  props.item.workingCountry != 'OMAN' &&
                  !props.item.isSaleOrderInQueue &&
                  !props.item.isAssignmentCustomerReceiptInitiated
                "
              >
                <!-- <div class="subheading muted">Generate Sales Invoice</div>
              <div class="heading"> -->
                <v-tooltip
                  top
                  class="milestone"
                  content-class="tooltip-op"
                  color="grey"
                >
                  <template slot="activator">
                    <button
                      v-permissions="'generate-downaload-so-si-for-accounts'"
                      @click="
                        open(
                          props.item.userData,
                          props.item.jobId,
                          props.item
                        )
                      "
                      type="button"
                      v-if="!props.item.isSaleInvoviceBackgroundProcess"
                      class="account-ass-btn"
                      :disabled="loading"
                      color="orange"
                      outline
                    >
                      <v-icon color="orange" small>settings</v-icon>SI
                    </button>
                  </template>
                  <span v-if="props.item.assignementSalesInvoiceGenerated"
                    >Assignment level sales invoice has already been generated
                    for this.</span
                  >

                  <span v-if="!props.item.assignementSalesInvoiceGenerated"
                    >Sale Invoice Generated Button</span
                  >
                </v-tooltip>

                <div
                  v-if="props.item.isSaleInvoviceBackgroundProcess"
                  style="word-break: break-word"
                >
                  Background process is ongoing.
                </div>
                <!-- </div> -->
              </v-flex>

              <div v-else>
                <v-flex
                  v-if="
                    props.item.invoiceNumber &&
                    props.item.isSalesInvoiceGenerated &&
                    props.item.workOrderCompleted &&
                    props.item.workingCountry != 'PAK'
                  "
                >
                  {{ props.item.invoiceNumber }}
                </v-flex>
                <v-flex
                  v-if="
                    props.item.invoicePdfUrl &&
                    props.item.isSalesInvoiceGenerated &&
                    props.item.workOrderCompleted &&
                    props.item.workingCountry != 'PAK'
                  "
                >
                  <v-layout
                    class="accounts-sales-invoice-actions"
                    style="text-align: center"
                  >
                    <v-flex style="text-align: end">
                      <button
                        class="download-ass-btn"
                        v-permissions="'generate-downaload-so-si-for-accounts'"
                        type="button"
                        color="orange"
                        title="Download Invoice"
                        :disabled="loading"
                        outline
                        @click="openDownloadAdvance(props.item, $event)"
                      >
                        <v-icon color="white" small>download</v-icon>
                      </button>
                    </v-flex>
                    <v-flex style="text-align: start; padding-left: 3px">
                      <SendSI
                        :jobId="props.item.jobId"
                        :email="props.item.userData.email"
                        :invoiceUrl="props.item.invoicePdfUrl"
                        :workingCountry="props.item.workingCountry"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </div>
            </td>
          </tr>
        </template>
        </v-data-table>
      </ScrollableTable>
      <pagination
        :totalPages="totalPages"
        :pages="this.pages"
        @pageNo="page"
        :url="`/dmsAdmin/accountSection`"
        :callback="callback"
        :componentKey="componentKey"
        :action="`accounts`"
        :payload="payload"
        :type="1"
        v-on:pagination-load="checkLoading"
      />
    </v-card-text>
    <v-dialog
      v-model="accountDetailDialog"
      content-class="accounts-detail-dialog"
      max-width="calc(100vw - 3rem)"
      scrollable
      @keydown.esc="closeAccountDetailDialog"
    >
      <v-card class="accounts-detail-modal-card" v-if="selectedAccountJob">
        <v-toolbar flat class="accounts-detail-modal-toolbar">
          <v-toolbar-title class="accounts-detail-modal-title">
            <span class="accounts-detail-modal-id">
              {{ selectedAccountJob.jobId }}
            </span>
            <span class="accounts-detail-modal-company">
              {{
                selectedAccountJob.companyName ||
                selectedAccountJob.customer
              }}
            </span>
            <span
              class="accounts-status-pill accounts-detail-modal-status"
              :class="{
                'accounts-status-pill--open':
                  selectedAccountJob.jobStatus === 1 ||
                  selectedAccountJob.jobStatus === 3 ||
                  selectedAccountJob.jobStatus === 4,
                'accounts-status-pill--moving':
                  selectedAccountJob.jobStatus === 5 ||
                  selectedAccountJob.jobStatus === 6 ||
                  selectedAccountJob.jobStatus === 7,
                'accounts-status-pill--pending':
                  selectedAccountJob.jobStatus === 8 ||
                  selectedAccountJob.jobStatus === 10,
                'accounts-status-pill--done':
                  selectedAccountJob.jobStatus === 9 ||
                  selectedAccountJob.jobStatus === 2,
                'accounts-status-pill--cancelled':
                  selectedAccountJob.jobStatus === -1
              }"
            >
              {{ jobsStatus(selectedAccountJob.jobStatus) }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="closeAccountDetailDialog">
            <v-icon class="heading grey--text text--darken-4">close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="accounts-detail-modal-body">
          <v-stepper
            v-if="assignments.length"
            v-model="e1"
            class="accounts-expanded-panel accounts-detail-stepper"
          >
            <v-stepper-header class="SubTypeTab">
              <template v-for="n in steps" class="bg-clr-tab">
                <v-stepper-step
                  :complete="e1 == n"
                  :key="`${n}-step`"
                  :step="n"
                  :editable="true"
                  color="orange darken-1"
                  :complete-icon="getModeIcon(jobTypeArray[n - 1])"
                  :edit-icon="getModeIcon(jobTypeArray[n - 1])"
                  class="bg-clr-tab"
                >
                  <span
                    >{{
                      assignments.length ? getJobType(jobTypeArray[n - 1]) : ""
                    }}
                    {{ n }}
                  </span>
                </v-stepper-step>
              </template>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                v-for="n in steps"
                :key="`${n}-content`"
                :step="n"
              >
                <TripInformation
                  :assignments="assignments[n - 1]"
                  :tabOrder="n"
                  :jobType="jobTypeArray[n - 1]"
                  :isAssignCustomerRecipt="isAssignCustomerRecipt[n - 1]"
                  :totalAdditionalAmountTab="totalAdditionalAmountTab[n - 1]"
                  :jobId="selectedAccountJob.jobId"
                  :jobGeography="selectedAccountJob.jobGeoType"
                  :isCustomerReceiptInitiate="
                    selectedAccountJob.isCustomerReceiptInitiate
                  "
                  :additionalCharges="selectedAccountJob.additionalCharges"
                  :isAssignmentCustomerReceiptInitiated="
                    selectedAccountJob.isAssignmentCustomerReceiptInitiated
                  "
                  :isJobActivatedByScript="
                    selectedAccountJob.isJobActivatedByScript
                  "
                  @account-list-refresh="
                    getAssignmentList(selectedAccountJob.jobId);
                    refresh();
                  "
                />
                <AssignmentList
                  :assignmentList="assignments[n - 1]"
                  :jobId="selectedAccountJob._id"
                  :jobData="selectedAccountJob"
                  :tabOrder="n"
                  @account-list-refresh="
                    getAssignmentList(selectedAccountJob.jobId);
                    refresh();
                  "
                  @account-assign-list-refresh="
                    getAssignmentList(selectedAccountJob.jobId)
                  "
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
    <CustomerAdvancePopup
      v-model="customerAdvanceDialog"
      :currency="customerAdvanceCurrency"
      :max-amount="customerAdvanceMax"
      advance-type="job"
      :advance-id="customerAdvanceId"
      :title="customerAdvanceCopy.title"
      :message="customerAdvanceCopy.message"
      :hint="customerAdvanceCopy.hint"
      :yes-text="customerAdvanceCopy.yesText"
      @confirm="onCustomerAdvanceConfirm"
      @cancel="onCustomerAdvanceCancel"
    />

    <GenerateInvoiceDialog
      :open="dialog1"
      v-model="bank"
      :banks="bankInfo"
      :loading="loading"
      @change="setCustomerValues"
      @cancel="closeBankInfo()"
      @confirm="generateInvoiceNumber()"
    >
      <div v-if="!userDetail.invoiceDay" slot="prompt">
        <p class="generate-invoice-lead">Set the credit duration first</p>
        <p class="generate-invoice-hint">
          This customer has no credit duration yet. Save one to continue to the
          invoice.
        </p>
        <label class="generate-invoice-label" for="generate-invoice-credit">
          Credit duration
        </label>
        <div class="generate-invoice-credit-row">
          <v-text-field
            id="generate-invoice-credit"
            v-model="invoiceDay"
            placeholder="e.g. 30"
            suffix="days"
            type="number"
            single-line
            hide-details
            class="generate-invoice-field"
          />
          <v-btn
            class="oms-btn oms-btn--primary"
            @click="addCreditDuration()"
            >Save</v-btn
          >
        </div>
      </div>
    </GenerateInvoiceDialog>

    <v-dialog v-model="confirmationDialog" max-width="28rem" persistent>
      <v-card>
        <v-spacer class="spacerclass">
          <v-card-text style="padding-top: 0px !important">
            <v-layout class="pt-4" style="text-align: center">
              <v-flex pr-2 pb-3>
                <v-icon x-large color="orange">info</v-icon></v-flex
              >
            </v-layout>
            <v-layout>
              <v-flex pb-3 style="text-align: center"> there </v-flex>
            </v-layout>
            <v-layout>
              <v-flex style="text-align: center">
                <v-btn
                  color="white darken-1"
                  style="
                    background: orange !important;
                    min-width: 66px !important;
                  "
                  flat
                  @click.prevent="confirm()"
                  >OK</v-btn
                ></v-flex
              >
            </v-layout>
          </v-card-text>
        </v-spacer>
      </v-card>
    </v-dialog>

    <success-dialog
      content="Successful"
      :show="x.registerSuccess"
      :onclose="closeRegistration"
    />
    <v-snackbar
      :timeout="3000"
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
  </v-card>
</template>
<script>
import moment from "moment";
import { EventBus } from "../../event-bus.js";
import { accountList } from "@/constants/datatable-headers.js";
import downloadMixin from "@/mixins/downloadMixin";
import SuccessDialog from "@/components/Common/SuccessDialog";
import activityLogs from "../Common/activityLogs";
import { StorageKeys } from "../../constants/constants";
import { updateJobCustomerAdvance } from "@/constants/api-urls";
import {
  apiErrorMessage,
  applyRebuiltInvoice,
} from "@/utils/customerAdvance";
import Swal from "sweetalert2";
import PriceType from "./Popups/PriceType";
import SendSI from "./Popups/SendSI";
import CustomerPrice from "./Popups/CustomerPrice";
import pagination from "@/components/Pagination/pagination";
import additionalChargesPopup from "../JobDocuments/additionalChargesPopup";
import TripInformation from "./TripInformation";
import AssignmentList from "./AssignmentList";
import Loading from "vue-loading-overlay";
import ScrollableTable from "@/components/Common/ScrollableTable";
import CustomerAdvancePopup from "@/components/Common/CustomerAdvancePopup.vue";
import GenerateInvoiceDialog from "@/components/Common/GenerateInvoiceDialog";
import { getModeIcon } from "@/utils/shipmentLabels";
export default {
  mixins: [downloadMixin],
  components: {
    ScrollableTable,
    GenerateInvoiceDialog,
    pagination,
    TripInformation,
    additionalChargesPopup,
    PriceType,
    SendSI,
    AssignmentList,
    activityLogs,
    Loading,
    CustomerPrice,
    CustomerAdvancePopup,
    SuccessDialog,
  },
  created() {
    this.$eventBus.$on("accounts-purchase-invoice", (data) => {
      this.refresh();
    });
    this.$eventBus.$on("accounts-purchase-invoice2", (data) => {
      this.refresh();
    });
    this.$eventBus.$on("accounts-purchase-order", (data) => {
      this.refresh();
    });
    this.$eventBus.$on("accounts-sales-order", (data) => {
      this.refresh();
    });
    this.$eventBus.$on("accounts-sales-invoice", (data) => {
      this.refresh();
    });

    //this.checkPermission("accounts");
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
      this.payload = {
        workingCountry: this.workingCountry,
      };
    }

    EventBus.$on("countryChanged", (val) => {
      this.workingCountry = val;
      this.loading = true;
      if (this.$route.name === "Accounts") {
        this.payload.workingCountry = this.workingCountry;
      }
    });
  },

  props: {
    searchText: String,
    dateRangenew: Array,
    dashboardData: Function,
    searchCustomer: String,
    resetCustomer: Boolean,
    loader: Boolean,
    TypeFilter: String,
    Type: String,
    count1: String,
    selectedCustInvoiceFailed: Object,
  },
  computed: {
    /* Generating asks whether there is an advance at all. Downloading an
       invoice that already has one is an edit, so it is worded as one. */
    customerAdvanceCopy() {
      if (this.customerAdvanceMode == "download") {
        return {
          title: "Edit Customer Advance",
          message:
            "Do you want to update the customer advance for this shipment?",
          hint: "Change the amount, or choose No to keep it as it is.",
          yesText: "Update",
        };
      }
      return {
        title: "Customer Advance",
        message: "Is there any customer advance for this shipment?",
        hint: "Enter the amount, or choose No if there is no advance.",
        yesText: "Yes",
      };
    },
  },
  watch: {
    count1(val) {
      this.generateInvoiceCount = val;
    },
    dateRangenew: function (n, o) {
      if (!n) {
        this.$eventBus.$emit("on-load");
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
      if (n) {
        this.$eventBus.$emit("on-load");
        this.loading = false;
        if (n.length && n[0] && n[1]) {
          this.startDate = moment(n[0]).format("YYYY-MM-DD");
          this.endDate = moment(n[1]).format("YYYY-MM-DD");
          this.getDashboardData(
            this.searchCustomer,
            this.startDate,
            this.endDate
          );
        }
        this.$set(this.payload, "startDate", this.startDate);

        this.payload.isSearch = "true";
        this.payload.endDate = this.endDate;
      } else {
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    pagination(val) {
      if (val["sortBy"] === "jobPrice") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "jobPrice";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "jobPrice";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      } else if (val["sortBy"] === "additionalCharges") {
        if (val["descending"] === true) {
          this.payload["sortBy"] = "additionalCharges";
          this.payload["sortType"] = -1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        } else if (val["descending"] === false) {
          this.payload["sortBy"] = "additionalCharges";
          this.payload["sortType"] = 1;
          this.componentKey = this.componentKey + 1;
          this.loading = true;
        }
      }

      if (!val["sortBy"]) {
        delete this.payload["sortType"];
        delete this.payload["sortBy"];
        if (val["descending"] == null) {
          this.componentKey = this.componentKey + 1;
        }
      }
      deep: true;
    },
    dateRange: function (n, o) {
      if (n != "") {
        this.$eventBus.$emit("on-load");
        this.loading = false;
        if (n.startDate && n.endDate) {
          this.startDate = moment(this.dateRange.startDate).format(
            "YYYY-MM-DD"
          );
          this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        }
        this.$set(this.payload, "startDate", this.startDate);

        this.payload.isSearch = "true";
        this.payload.endDate = this.endDate;
      } else {
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
    searchText: function (n, o) {
      if (n.trim() != "") {
        this.$eventBus.$emit("on-load");
        this.loading = false;

        this.payload.isSearch = "true";

        this.payload.searchType = this.Type;
        this.$set(this.payload, "searchText", n);
      }
    },
    searchCustomer: function (n, o) {
      this.generateInvoiceCount = 0;
      this.$emit("count", this.generateInvoiceCount);
      this.$emit("jobList-Id", []);
      this.customerSearchData = n;
      this.selectedids = [];
      this.selectednames = [];
      if (n) {
        this.$eventBus.$emit("on-load");
        if (
          this.$props.dateRangenew &&
          this.$props.dateRangenew[0] &&
          this.$props.dateRangenew[1]
        ) {
          this.startDate = moment(n[0]).format("YYYY-MM-DD");
          this.endDate = moment(n[1]).format("YYYY-MM-DD");
          this.getDashboardData(n, this.startDate, this.endDate);
        } else {
          this.getDashboardData(n);
        }
        this.loading = false;

        this.payload.isSearch = "true";
        this.$set(this.payload, "customerId", n);
      }
    },
    selectedCustInvoiceFailed: function (n, o) {
      this.openOnInvoiceFail(n);
    },

    resetCustomer: function (n, o) {
      if (n) {
        this.selectedids = [];
        this.selectednames = [];
        this.customerSearchData = null;
        this.generateInvoiceCount = 0;
        this.$eventBus.$emit("on-load");
        this.payload = {
          workingCountry: this.workingCountry,
        };
      }
    },
  },

  data() {
    return {
      e1: 1,
      steps: 1,
      customerSearchData: null,
      confirmationDialog: false,
      confirmation: "",
      singleExpand: true,
      invoicingCity: "",
      invoicingCountry: "",
      bankInfo: [],
      bankName: [],
      bank: "",
      beneficiaryName: "",
      branchCode: "",
      ibanNo: "",
      swiftCode: "",
      accountNo: "",
      bankId: "",
      generateInvoiceCount: 0,
      error: null,
      subJobArray: [],
      assignments: [],
      isAssignCustomerRecipt: [],
      totalAdditionalAmountTab: [],
      jobTypeArray: [],
      isAssignDriver: [],
      valid: true,
      x: {
        registerSuccess: false,
      },
      options: {
        color: "#ffc04c",
        width: 450,
        zIndex: 200,
      },
      pagination: {},
      dialog1: false,
      customerAdvanceDialog: false,
      customerAdvanceCurrency: "",
      customerAdvanceMax: null,
      customerAdvanceAmount: null,
      customerAdvanceId: null,
      customerAdvanceMode: "generate",
      siWorkingCountry: "",
      pendingDownload: null,
      pendingSiRequest: null,
      accountDetailDialog: false,
      selectedAccountJob: null,
      workingCountry: null,
      userDetail: {},
      invoiceDay: null,
      operationName: "",
      id: null,
      selected: [],
      selectedids: [],
      selectednames: [],
      componentKey: 0,
      showScreen: true,
      totalPages: 0,
      loading: false,
      pages: 1,
      payload: {
        workingCountry: this.workingCountry,
      },

      headers: accountList,
      items: [],
      isMultipleInvoiceFailed: false,
    };
  },
  methods: {
    getModeIcon,
    stop(e) {
      e.stopPropagation();
    },
    shouldIgnoreAccountRowClick(event) {
      if (!event || !event.target || !event.target.closest) return false;

      return Boolean(
        event.target.closest(
          [
            "button",
            "a",
            "input",
            "textarea",
            "select",
            ".v-btn",
            ".v-icon",
            ".v-input",
            ".v-menu",
            ".v-tooltip",
            ".account-disabled-ass-btn",
            ".account-ass-btn",
            ".download-ass-btn",
            ".track-ass-btn",
          ].join(",")
        )
      );
    },
    openAccountDetail(item, event, force = false) {
      if (!item || (!force && this.shouldIgnoreAccountRowClick(event))) return;

      this.selectedAccountJob = item;
      this.e1 = 1;
      this.steps = 0;
      this.assignments = [];
      this.jobTypeArray = [];
      this.subJobArray = [];
      this.isAssignDriver = [];
      this.isAssignCustomerRecipt = [];
      this.totalAdditionalAmountTab = [];
      this.accountDetailDialog = true;
      this.getAssignmentList(item.jobId);
    },
    closeAccountDetailDialog() {
      this.accountDetailDialog = false;
    },
    toDataURL(url) {
      return fetch(url)
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          return URL.createObjectURL(blob);
        });
    },

    confirm() {
      this.confirmationDialog = false;
    },
    page(event) {
      this.pages = event;
    },
    setCustomerValues(val) {
      var data = this.bankInfo.filter((v) => {
        if (v.value === val) return v;
      });
      (this.beneficiaryName = data[0].beneficiaryName),
        (this.branchCode = data[0].branchCode),
        (this.accountNo = data[0].accountNo),
        (this.ibanNo = data[0].ibanNo),
        (this.bankId = data[0].bankId),
        (this.swiftCode = data[0].swiftCode);
      // this.beneficiaryName = data[0].beneficiaryName;
    },
    checkLoading(event) {
      if (event) {
        this.loading = true;
      } else {
        // this.$emit("job-load", false);
        this.loading = false;
      }
    },
    addCreditDuration() {
      if (!this.invoiceDay) {
        this.loading = false;
        this.error = "Please enter the credit duration";
        return;
      }

      if (!this.invoiceDay.match(/^([1-9][0-9]{0,3}|10000)$/)) {
        this.loading = false;
        this.error =
          "Please enter valid duration greater than 0 less than 10000";
        return;
      }
      this.loading = true;
      let url = "/dmsAdmin/editInvoiceDay";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        userId: this.userDetail._id,
        invoiceDay: parseInt(this.invoiceDay),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.userDetail.invoiceDay = this.invoiceDay;
          //this.items = response.data.data;
          if (this.isMultipleInvoiceFailed) {
            this.selectedids = [];
            this.selectednames = [];
            this.generateInvoiceCount = 0;
            this.$emit("count", this.generateInvoiceCount);
            this.$emit("jobList-Id", []);
            this.isMultipleInvoiceFailed = false;
            this.dialog1 = false;
          }
          this.loading = false;
          this.refresh();
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    fetchBank() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        invoicingCity: {
          code: this.userDetail.invoicingCity,
        },
        invoicingCountry: {
          code: this.userDetail.invoicingCountry,
        },
      };
      let { apiUrl } = this.constants;
      this.axios.post(`${apiUrl}/accounts/getBankDetails`, body, config).then(
        (response) => {
          const { data = null } = response.data;
          /* Replace, never append, so reopening the bank step does not list
             every bank again. */
          this.bankInfo = data.map((element) => ({
            text: element.bankName,
            value: element._id,
            beneficiaryName: element.beneficiaryName,
            branchCode: element.branchCode,
            accountNo: element.accountNo,
            ibanNo: element.ibanNo,
            bankId: element._id,
            swiftCode: element.swiftCode,
          }));
        },
        (error) => {
          this.error = "Something went wrong. Please try again later!";
          this.loading = false;
        }
      );
    },

    getDashboardData(customerId, startDate, endDate) {
      this.loading = true;
      let url = "/dmsAdmin/jobCountForAccounts";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        workingCountry: this.workingCountry,
      };
      if (customerId) {
        body.customerId = customerId;
      }
      if (startDate && this.endDate) {
        body.startDate = startDate;
        body.endDate = endDate;
      }
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          const data = response.data.data;
          this.dashboardData(data);

          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to Fetch Data";
          this.loading = false;
        }
      );
    },
    openOnInvoiceFail(userData) {
      this.isMultipleInvoiceFailed = true;
      this.dialog1 = true;
      this.userDetail = userData;
    },
    async open(userData, id, jobData) {
      /* Kept so the payload can be gated on the working country at the
         moment the invoice is generated. */
      this.siWorkingCountry = (jobData && jobData.workingCountry) || "";
      /* For UAE, ask for the customer advance first. Every other working
         country, and anyone who cannot generate the sales invoice, keeps
         going straight into the existing sales invoice flow. */
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (jobData && jobData.workingCountry == "UAE" && y) {
        this.customerAdvanceAmount = null;
        this.customerAdvanceCurrency = jobData.customerCurrency || "";
        /* The popup prefills itself from this job's saved advance, and caps
           on the invoice amount that comes back with it. */
        this.customerAdvanceId = id;
        this.customerAdvanceMode = "generate";
        this.pendingSiRequest = { userData, id };
        this.customerAdvanceDialog = true;
        return;
      }
      this.startSiFlow(userData, id);
    },

    /* Downloading an invoice that already has an advance is an edit, so it
       asks first and then hands back the regenerated PDF. */
    async openDownloadAdvance(item, e) {
      if (e) e.stopPropagation();
      this.pendingDownload = {
        url: item.invoicePdfUrl,
        isDownloadInvocie: item.isDownloadInvocie,
        isSaleInvoviceBackgroundProcess: item.isSaleInvoviceBackgroundProcess,
        invoiceNumber: item.invoiceNumber,
      };
      /* Only whoever can generate the sales invoice may edit the advance,
         everyone else just downloads it. */
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (item.workingCountry == "UAE" && y) {
        this.customerAdvanceAmount = null;
        this.customerAdvanceCurrency = item.customerCurrency || "";
        this.customerAdvanceId = item.jobId;
        this.siWorkingCountry = item.workingCountry;
        this.customerAdvanceMode = "download";
        this.customerAdvanceDialog = true;
        return;
      }
      this.runPendingDownload();
    },

    runPendingDownload() {
      const pending = this.pendingDownload;
      this.pendingDownload = null;
      if (!pending) return;
      this.checkViewInvoice(
        pending.url,
        pending.isDownloadInvocie,
        pending.isSaleInvoviceBackgroundProcess,
        pending.invoiceNumber,
        { stopPropagation() {} }
      );
    },

    /* Editing the advance regenerates the invoice, so the download holds
       until the refreshed row carries the new PDF. */
    saveAdvanceThenDownload(jobId, amount) {
      this.loading = true;
      const fallbackNumber = this.pendingDownload
        ? this.pendingDownload.invoiceNumber
        : "";
      this.saveJobCustomerAdvance(jobId, amount).then((invoice) => {
        this.loading = false;
        this.pendingDownload = null;
        if (!invoice) return;
        /* The rebuilt PDF is uploaded under a fresh name, so its URL comes
           back on this response. accountSection is cached and would still
           hand back the previous one. */
        const url = invoice.invoicePdfUrl;
        if (!url) {
          this.error =
            "The invoice was updated but its PDF link was not returned. Please try the download again.";
          return;
        }
        this.checkViewInvoice(
          url,
          true,
          false,
          invoice.invoiceNumber || fallbackNumber,
          { stopPropagation() {} }
        );
        /* On a combined invoice the rebuilt PDF belongs to several jobs, so
           every one of their rows gets the new link, not just this one. */
        applyRebuiltInvoice(this.items, invoice, (row) => row.jobId);
        /* Refresh so the rows reflect the new advance once the cache clears. */
        this.componentKey = this.componentKey + 1;
      });
    },

    /* Both No and Yes resume the flow that opened the popup, Yes also keeps
       whatever amount was entered. */
    onCustomerAdvanceConfirm({ confirmed, amount }) {
      this.customerAdvanceAmount = amount;
      const shouldSave = confirmed && amount !== null;

      if (this.customerAdvanceMode == "download") {
        if (shouldSave) {
          this.saveAdvanceThenDownload(this.customerAdvanceId, amount);
        } else {
          this.runPendingDownload();
        }
        return;
      }

      const pending = this.pendingSiRequest;
      this.pendingSiRequest = null;
      if (shouldSave) {
        this.saveJobCustomerAdvance(this.customerAdvanceId, amount);
      }
      if (!pending) return;
      this.startSiFlow(pending.userData, pending.id);
    },

    onCustomerAdvanceCancel() {
      this.customerAdvanceAmount = null;
      this.pendingSiRequest = null;
      this.pendingDownload = null;
    },

    /* Saves the advance against the job. The sales invoice flow carries on
       either way, a failure is surfaced but does not block it. */
    saveJobCustomerAdvance(jobId, amount) {
      if (!jobId || this.siWorkingCountry != "UAE") {
        return Promise.resolve(false);
      }
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: jobId.toString(), customerAdvance: amount };
      return this.axios
        .post(this.constants.apiUrl + updateJobCustomerAdvance, body, config)
        .then(
          (response) => {
            /* The response carries the rebuilt invoice, including its new
               PDF URL. */
            const payload = response.data || {};
            return payload.data || payload;
          },
          (error) => {
            this.error = apiErrorMessage(
              error,
              "Could not save the customer advance."
            );
            return null;
          }
        );
    },

    startSiFlow(userData, id) {
      this.dialog1 = true;
      this.userDetail = userData;
      this.fetchBank();
      this.id = id;
    },
    closeRegistration() {
      this.x.registerSuccess = false;
      // this.componentKey=this.componentKey+1
    },
    refresh() {
      this.componentKey = this.componentKey + 1;
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    getAssignmentList(jobId) {
      this.loading = true;
      let url = "/dmsAdmin/jobDetailsForAccount";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        jobId: jobId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          const data = response.data.data;
          this.invoicingCity = response.data.data.jobInfo.invoicingCity;
          this.invoicingCountry = response.data.data.jobInfo.invoicingCompany;
          const status = response.status;
          const { jobInfo = null, assignmentList = [] } = data;
          var size = assignmentList.length;
          this.steps = size;
          this.assignments = [];
          this.jobTypeArray = [];
          this.subJobArray = [];
          for (var i = 0; i < size; i++) {
            this.assignments[i] = assignmentList[i].assignmentListing;
            this.isAssignDriver[i] = assignmentList[i].isAssignDriver;
            this.jobTypeArray[i] = assignmentList[i].jobType || "1";
            this.subJobArray[i] = assignmentList[i];
            this.isAssignCustomerRecipt[i] =
              assignmentList[i].isCustomerReceiptInitiated;
            this.totalAdditionalAmountTab[i] =
              assignmentList[i].totalAdditionalAmount;

            var prices = {
              driverCost: null,
              customerCost: null,
              trukkinCost: null,
              AdditionalCost: null,
            };
          }
          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to Fetch Data";
          this.loading = false;
        }
      );
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Active";
        case 2:
          return "Complete";
        case 3:
          return "Customer Rate Accepted";
        case 4:
          return "Finding Drivers";
        case 5:
          return "Driver Assigned";
        case 6:
          return "In-Transit";
        case 7:
          return "Shipment Offloaded";
        case 8:
          return "Payment Pending";
        case 9:
          return "Payment Done";
        case 10:
          return "Low Credit Limit";

        case -1:
          return "Job Cancelled";
        default:
          return "Unknown";
      }
    },
    retry(jobId) {
      this.loading = true;
      let url = "/dmsAdmin/generateWorkOrder";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { jobId: jobId.toString() };

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.x.registerSuccess = true;
          this.x.message = response.data.data.message;
          this.loading = false;
          this.refresh();
          this.getAssignmentList(jobId);
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.loading = false;
          this.error = error.response.data.message;
        }
      );
    },
    async retrySO(jobId) {
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        let url = "/dmsAdmin/generateSaleOrder";
        this.loading = true;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { jobId: jobId.toString() };

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.x.registerSuccess = true;
            this.x.message = response.data.data.message;
            this.loading = false;
            this.refresh();
            this.getAssignmentList(jobId);
            setTimeout(() => (this.dialog = false), 100);
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },
    async checkViewInvoice(
      url,
      isDownloadInvocie,
      isSaleInvoviceBackgroundProcess,
      invoiceNumber,
      e
    ) {
      this.loading = true;
      e.stopPropagation();
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        if (!isDownloadInvocie || isSaleInvoviceBackgroundProcess) {
          this.loading = false;
          this.error = "Background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.loading = false;
        this.forceDownload(url, "Sales Invoice" + " " + invoiceNumber);
      } else {
        this.loading = false;
        return;
      }
    },
    async generateInvoiceNumber() {
      this.loading = true;
      this.operationName = "generate-downaload-so-si-for-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (!this.bank) {
        this.loading = false;
        this.error = "Please choose bank before generating the invoice";
        return;
      }
      if (y) {
        this.loading = true;
        if (!this.userDetail.invoiceDay) {
          this.loading = false;
          this.error = "Please enter the credit limit duration";
          return;
        }
        let url = "/dmsAdmin/generateSalesInvoice";
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { jobId: this.id.toString(), bankId: this.bankId };
        /* Customer advance is UAE only. KSA and every other working country
           keep the payload they had before. */
        if (
          this.siWorkingCountry == "UAE" &&
          this.customerAdvanceAmount !== null
        ) {
          body.customerAdvance = this.customerAdvanceAmount;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            //this.items = response.data.data;
            this.loading = false;
            this.x.registerSuccess = true;
            this.closeBankInfo();
            this.customerAdvanceAmount = null;
            this.getAssignmentList(this.id);
            this.componentKey = this.componentKey + 1;
            // this.x.message = "Drivers notified";
          },
          (error) => {
            this.loading = false;
            this.error = error.response.data.message;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },
    async check(id) {
      this.loading = true;
      this.operationName = "view-accounts";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        this.goToProfile(id);
      } else {
        this.loading = false;
        return;
      }
    },
    closeBankInfo() {
      this.dialog1 = false;
      this.customerAdvanceAmount = null;
      this.invoiceDay = null;
      this.isMultipleInvoiceFailed = false;
      this.bankInfo = [];
      this.bank = "";
      (this.beneficiaryName = ""),
        (this.branchCode = ""),
        (this.accountNo = ""),
        (this.ibanNo = ""),
        (this.bankId = ""),
        (this.swiftCode = "");
    },
    checkPermission(operation) {
      const { serverUrl, rbacUrl, apiUrl } = this.constants;
      this.$http
        .post(`${rbacUrl}/checkUserPermission`, {
          userId: localStorage.getItem("userId"),
        })
        .then((res) => {
          if (!res.data.data) {
            this.loading = false;
          }
          let old = res.data.data.roles;
          old = old.map((x) => x.role.roleName.toLowerCase());
          let roles = JSON.parse(localStorage.getItem("permissions")).roles;
          roles = roles.map((x) => x.role.roleName.toLowerCase());
          old.sort();
          roles.sort();
          if (old.toString() != roles.toString()) {
            this.showScreen = false;
            localStorage.setItem("permissions", JSON.stringify(res.data.data));
            Swal.fire({
              title: "Oops!",
              text: "Your permissions have changed .",
              type: "error",
              allowOutsideClick: false,
              confirmButtonColor: "orange",
              confirmButtonText: "Okay",
            }).then((result) => {
              localStorage.setItem("first-load", true);
              this.$router.replace("/");
              location.reload();
            });
          }
          if (old.toString() == roles.toString()) {
            localStorage.setItem("permissions", JSON.stringify(res.data.data));
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    getTime3(date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },
    callback(res) {
      this.$eventBus.$emit("off-load");
      this.loading = false;
      this.items = res.jobInfo;
      this.items.forEach((e) => {
        e.selected = false;
        if (this.selectedids.includes(e.jobId)) {
          e.selected = true;
        }
      });

      this.totalPages = Math.ceil(res.totalData / 15);
      this.pagination.rowsPerPage = 15;
    },
    paginationPayload(event) {
      this.payload = event;
    },

    getTime(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },

    checkSelected(select, id, e) {
      if (select && !this.selectedids.includes(id)) {
        this.generateInvoiceCount = this.generateInvoiceCount + 1;
        this.$emit("count", this.generateInvoiceCount);
        this.selectedids.push(id);
        this.selectednames.push(id);
      }
      if (!select && this.selectedids.includes(id)) {
        this.generateInvoiceCount = this.generateInvoiceCount - 1;
        this.$emit("count", this.generateInvoiceCount);
        this.selectedids.splice(this.selectedids.indexOf(id), 1);
        this.selectednames.splice(this.selectednames.indexOf(id), 1);
      }
      this.$emit("jobList-Id", this.selectednames);
      /* The customer advance popup needs each selected job's rate, currency
         and working country, which only the row carries. */
      this.$emit(
        "jobList-Rows",
        this.items.filter((e) => this.selectednames.includes(e.jobId))
      );
      this.$emit("selectedCustomerData", this.items[0]["userData"]);
    },
  },
};
</script>
<style scoped>
.accounts-list-card {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0 1.5rem 1.5rem !important;
  max-width: none !important;
  overflow: visible !important;
  padding: 0 !important;
}

.accounts-table-card {
  background: transparent;
  overflow: visible;
  padding: 0 !important;
}

.accounts-table-scroll {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.accounts-modern-table {
  background: transparent;
}

.accounts-modern-table ::v-deep .v-table__overflow {
  background: #ffffff;
  border: 1px solid #e4e8f0;
  border-radius: 8px;
  -webkit-overflow-scrolling: touch;
  overflow-x: auto;
  width: 100%;
}

.accounts-modern-table ::v-deep table.v-table {
  border-collapse: separate;
  border-spacing: 0 6px;
  min-width: var(--accounts-job-table-min-width, 100%);
  table-layout: fixed;
  width: 100%;
}

.accounts-modern-table ::v-deep table.v-table thead tr {
  background: transparent;
}

.accounts-modern-table ::v-deep table.v-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}

.accounts-modern-table ::v-deep table.v-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}

.accounts-modern-table ::v-deep table.v-table tbody tr.accounts-data-row {
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.045);
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.accounts-modern-table ::v-deep table.v-table tbody tr.accounts-data-row:hover {
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.accounts-modern-table
  ::v-deep
  table.v-table
  tbody
  tr.accounts-data-row:hover
  td {
  background: #fbfdff;
}

.accounts-modern-table ::v-deep table.v-table tbody td {
  background: #ffffff;
  border-bottom: 1px solid #e7ecf3 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 1px solid #e7ecf3 !important;
  color: #2e3748;
  font-size: 13px !important;
  height: auto;
  line-height: 1.35;
  padding: 10px 8px !important;
  text-align: left !important;
  vertical-align: middle;
}

.accounts-modern-table ::v-deep table.v-table thead th,
.accounts-modern-table ::v-deep table.v-table tbody td {
  box-sizing: border-box;
}

.accounts-modern-table ::v-deep table.v-table thead th {
  overflow: visible;
  line-height: 1.2;
  padding-left: 8px !important;
  padding-right: 8px !important;
  white-space: normal;
}

.accounts-modern-table ::v-deep table.v-table tbody td {
  height: auto;
  min-height: 4.875rem;
  overflow: visible;
  overflow-wrap: break-word;
  vertical-align: middle !important;
  word-break: normal;
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(1),
.accounts-modern-table ::v-deep table.v-table td:nth-child(1) {
  width: var(--oms-list-col-1, 7%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(2),
.accounts-modern-table ::v-deep table.v-table td:nth-child(2) {
  text-align: center !important;
  width: var(--oms-list-col-2, 6.5%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(3),
.accounts-modern-table ::v-deep table.v-table td:nth-child(3) {
  width: var(--oms-list-col-3, 13%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(4),
.accounts-modern-table ::v-deep table.v-table td:nth-child(4) {
  text-align: right !important;
  width: var(--oms-list-col-4, 8%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(5),
.accounts-modern-table ::v-deep table.v-table td:nth-child(5) {
  width: var(--oms-list-col-5, 10%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(6),
.accounts-modern-table ::v-deep table.v-table td:nth-child(6) {
  width: var(--oms-list-col-6, 7%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(7),
.accounts-modern-table ::v-deep table.v-table td:nth-child(7) {
  width: var(--oms-list-col-7, 10%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(8),
.accounts-modern-table ::v-deep table.v-table td:nth-child(8) {
  text-align: right !important;
  width: var(--oms-list-col-8, 7%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(9),
.accounts-modern-table ::v-deep table.v-table td:nth-child(9) {
  text-align: center !important;
  width: var(--oms-list-col-9, 7%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(10),
.accounts-modern-table ::v-deep table.v-table td:nth-child(10) {
  width: var(--oms-list-col-10, 12.25%);
}

.accounts-modern-table ::v-deep table.v-table th:nth-child(11),
.accounts-modern-table ::v-deep table.v-table td:nth-child(11) {
  width: var(--oms-list-col-11, 12.25%);
}

.accounts-modern-table ::v-deep table.v-table tbody td:first-child {
  border-left: 4px solid #f58220 !important;
  border-radius: 8px 0 0 8px;
  color: #b95d07;
  font-weight: 700;
  padding-left: 8px !important;
}

.accounts-modern-table ::v-deep table.v-table tbody td:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid #eef1f5 !important;
}

.accounts-modern-table ::v-deep table.v-table tbody tr:hover td:first-child {
  border-left-color: #2563eb !important;
}

.accounts-job-id-row {
  align-items: center;
  display: flex;
  gap: 7px;
  justify-content: center !important;
  margin: 0 !important;
  min-height: 48px;
}

.accounts-job-id {
  color: #0f172a;
  font-size: clamp(0.6875rem, 0.54vw, 0.8125rem);
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.15;
  overflow: visible;
  white-space: nowrap;
}

.accounts-job-cell ::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.accounts-job-cell ::v-deep .v-label {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
}

.accounts-country-cell {
  color: #475569 !important;
  font-size: 11px !important;
  font-weight: 800;
  text-align: center !important;
  text-transform: uppercase;
}

.accounts-country-cell img {
  border-radius: 999px;
  box-shadow: 0 0 0 1px #e2e8f0;
  object-fit: cover;
  width: 28px;
}

.accounts-company-cell {
  color: #1f2937 !important;
  font-weight: 800;
  line-height: 1.35;
  min-width: 0;
  overflow: visible;
  overflow-wrap: anywhere;
  white-space: normal;
}

.accounts-money-cell {
  color: #0f172a !important;
  font-size: clamp(0.6875rem, 0.54vw, 0.8125rem) !important;
  font-weight: 900;
  line-height: 1.3;
  white-space: nowrap;
}

.accounts-money-cell .layout,
.accounts-price-type-cell .layout,
.accounts-charges-cell .layout {
  align-items: center;
  display: flex;
  gap: 7px;
  justify-content: flex-start;
  margin: 0 !important;
  min-height: 48px;
}

.accounts-money-cell .layout {
  justify-content: flex-end;
}

.accounts-money-cell .layout > .flex,
.accounts-price-type-cell .layout > .flex,
.accounts-charges-cell .layout > .flex {
  flex: 0 1 auto;
}

.accounts-money-cell span,
.accounts-price-type-cell span {
  padding-top: 0 !important;
}

.accounts-status-pill {
  align-items: center;
  background: #f1f5f9;
  border-radius: 999px;
  box-sizing: border-box;
  color: #475569;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  max-width: 100%;
  min-width: 112px;
  overflow-wrap: anywhere;
  padding: 8px 10px;
  text-align: center;
  white-space: normal;
  word-break: normal;
}

.accounts-status-cell {
  overflow: hidden !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  text-align: center !important;
}

.accounts-status-pill--open {
  background: #fff7ed;
  color: #c2410c;
}

.accounts-status-pill--moving {
  background: #eff6ff;
  color: #1d4ed8;
}

.accounts-status-pill--pending {
  background: #fef3c7;
  color: #92400e;
}

.accounts-status-pill--done {
  background: #ecfdf5;
  color: #047857;
}

.accounts-status-pill--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

.accounts-price-type-cell {
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 800;
  line-height: 1.35;
  min-width: 0;
}

.accounts-charges-cell {
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 700;
  line-height: 1.45;
  min-width: 0;
}

.accounts-charges-cell .layout {
  justify-content: space-between;
}

.accounts-charges-cell ::v-deep .layout > div {
  min-width: 0;
}

.accounts-charges-cell ::v-deep .flex div {
  padding-top: 2px !important;
}

.accounts-driver-rate-cell {
  min-width: 0;
}

.accounts-action-cell {
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 700;
  line-height: 1.35;
  min-width: 0;
  text-align: center !important;
  white-space: normal;
}

.accounts-action-cell ::v-deep .flex,
.accounts-action-cell ::v-deep .layout {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  margin: 0 !important;
  min-height: 40px;
  text-align: center !important;
}

.accounts-action-cell ::v-deep .layout {
  flex-direction: column;
}

.accounts-action-cell ::v-deep .layout > .flex {
  flex: 0 0 auto;
  text-align: center !important;
}

.accounts-action-cell > div,
.accounts-action-cell > .flex {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-height: 40px;
}

.accounts-sales-order-cell,
.accounts-sales-invoice-cell {
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 700;
}

.accounts-list-card .track-ass-btn,
.accounts-list-card .account-ass-btn {
  align-items: center !important;
  background: #ea7a1c !important;
  border: 1px solid #ea7a1c !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: #ffffff !important;
  cursor: pointer;
  display: inline-flex !important;
  font-family: inherit;
  font-size: 12px !important;
  font-weight: 600 !important;
  justify-content: center;
  letter-spacing: 0 !important;
  line-height: 14px !important;
  margin: 0 auto 8px !important;
  min-height: 32px !important;
  min-width: 0 !important;
  max-width: 100%;
  padding: 8px 12px !important;
  text-decoration: none !important;
  text-transform: none !important;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  white-space: nowrap !important;
}

.accounts-action-cell .track-ass-btn,
.accounts-action-cell .account-ass-btn,
.accounts-action-cell .account-disabled-ass-btn,
.accounts-action-cell .download-ass-btn {
  display: flex !important;
  margin-bottom: 8px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.accounts-action-cell .track-ass-btn:last-child,
.accounts-action-cell .account-ass-btn:last-child,
.accounts-action-cell .account-disabled-ass-btn:last-child,
.accounts-action-cell .download-ass-btn:last-child {
  margin-bottom: 0 !important;
}

.accounts-list-card .track-ass-btn:hover,
.accounts-list-card .account-ass-btn:hover {
  background: #d96a10 !important;
  border-color: #d96a10 !important;
  box-shadow: none !important;
  transform: translateY(-1px);
}

.accounts-list-card .download-ass-btn {
  align-items: center !important;
  background: #2563eb !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 12px rgba(37, 99, 235, 0.2) !important;
  display: inline-flex !important;
  justify-content: center;
  min-height: 32px;
  min-width: 2rem;
  padding: 8px 10px !important;
}

.accounts-list-card .account-disabled-ass-btn {
  align-items: center !important;
  background: #f4f3ee !important;
  border: 1px solid #e9e6de !important;
  border-radius: 8px !important;
  color: #b4b0a6 !important;
  display: inline-flex !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  justify-content: center;
  min-height: 32px;
  min-width: 0 !important;
  max-width: 100%;
  padding: 8px 12px !important;
  text-decoration: none !important;
  white-space: nowrap;
}

.accounts-expanded-panel {
  background: #f8fafc !important;
  border: 1px solid #e4e8f0;
  border-radius: 8px;
  box-shadow: none !important;
  margin: 4px 0 8px;
  overflow: visible;
}

.accounts-expanded-panel ::v-deep .v-stepper__header {
  background: #ffffff;
  border-bottom: 1px solid #e4e8f0;
  box-shadow: none !important;
  min-height: 48px;
}

.accounts-expanded-panel ::v-deep .v-stepper__step {
  border-radius: 8px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  padding: 12px 14px;
}

.accounts-expanded-panel ::v-deep .v-stepper__content {
  padding: 14px !important;
}

.accounts-detail-modal-card {
  background: var(--oms-bg, #f6f5f2) !important;
  max-height: calc(100vh - 3rem);
  overflow: hidden !important;
}

.accounts-detail-modal-toolbar {
  background: #ffffff !important;
  border-bottom: 1px solid var(--oms-border, #e4e1d9);
  position: sticky;
  top: 0;
  z-index: 4;
}

.accounts-detail-modal-title {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
  width: 100%;
}

.accounts-detail-modal-id {
  color: var(--oms-primary, #ea7a1c);
  flex: 0 0 auto;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0;
}

.accounts-detail-modal-company {
  color: var(--oms-ink-strong, #1a1916);
  flex: 1 1 auto;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.accounts-detail-modal-status {
  flex: 0 0 auto;
  min-width: max-content;
}

.accounts-detail-modal-body {
  background: var(--oms-bg, #f6f5f2);
  max-height: calc(100vh - 7rem);
  overflow: auto;
  padding: 14px !important;
}

.accounts-detail-stepper {
  background: transparent !important;
  border: 0;
  margin: 0;
}

.accounts-detail-stepper ::v-deep .v-stepper__header {
  border: 1px solid var(--oms-border, #e4e1d9);
  border-radius: 8px 8px 0 0;
  min-height: 46px;
  overflow-x: auto;
}

.accounts-detail-stepper ::v-deep .v-stepper__step {
  flex: 0 0 auto;
  min-height: 46px;
  white-space: nowrap;
}

.accounts-detail-stepper ::v-deep .v-stepper__content {
  background: #ffffff;
  border: 1px solid var(--oms-border, #e4e1d9);
  border-radius: 0 0 8px 8px;
  border-top: 0;
  padding: 14px !important;
}

.accounts-detail-modal-body ::v-deep .accounts-trip-card {
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  box-shadow: none !important;
  margin-bottom: 12px;
  padding: 14px !important;
}

.accounts-detail-modal-body ::v-deep .accounts-assignment-list {
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  box-shadow: none !important;
  min-width: 0;
  overflow: visible;
}

.accounts-detail-modal-body ::v-deep .accounts-assignment-table-card {
  padding: 0 !important;
}

.accounts-list-card ::v-deep .v-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.page-count-span {
  float: right;
  margin-top: 26px;
  color: darkorange;
}
.fonthead {
  font-size: 20px;
}
.download-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: blue;
  border-radius: 5px;
  border: 2px solid blue;
  padding: 3px 5px;
  margin-right: 2px;
}
/* .track-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #ffc278;
  border-radius: 5px;
  border: 2px solid darkorange;
  padding: 2px 5px;
} */

.account-ass-btn {
  text-decoration: none;
  color: #ea7a1c;
  border: 1px solid #ea7a1c;
  padding: 2px 8px;
  border-radius: 5px;
  margin-top: 6px;
}
.account-disabled-ass-btn {
  text-decoration: none;
  color: #b4b0a6;
  border: 1px solid #e9e6de;
  padding: 2px 8px;
  border-radius: 5px;
}
.v-stepper__header {
  justify-content: left !important;
}

@media (max-width: 760px) {
  .accounts-table-scroll {
    --accounts-job-table-min-width: 100rem;
  }

  .accounts-table-card {
    margin-left: 12px;
    margin-right: 12px;
    max-width: none;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .accounts-modern-table ::v-deep .v-table__overflow {
    border-radius: 8px;
  }

  .accounts-modern-table ::v-deep table.v-table {
    min-width: var(--accounts-job-table-min-width, 100rem);
  }

  .accounts-modern-table ::v-deep table.v-table thead th,
  .accounts-modern-table ::v-deep table.v-table tbody td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .accounts-list-card .track-ass-btn,
  .accounts-list-card .account-ass-btn,
  .accounts-list-card .account-disabled-ass-btn {
    min-width: max-content !important;
    width: auto;
  }

  .accounts-detail-modal-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .accounts-detail-modal-company {
    white-space: normal;
  }

  .accounts-detail-modal-body {
    max-height: calc(100vh - 6rem);
    padding: 10px !important;
  }
}

</style>
